import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap';
import styles from './CurrencySelect.scss';
import { currencySigns } from 'lib/support';

export default class CurrencySelect extends Component {

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    currentCurrency: PropTypes.string.isRequired,
    availableOptions: PropTypes.object.isRequired,
  };

  state = {
    dropdownOpen: false
  }

  toggle = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  renderOption(option) {
    return (
      <DropdownItem
        key={option}
        onClick={() => this.props.onChange(option)}
        disabled={this.props.currentCurrency === option}
      >
        {option}
      </DropdownItem>
    );
  }

  render() {
    const { currentCurrency, availableOptions } = this.props;
    const selectorActive = availableOptions.size > 1;
    const arrowSign = String.fromCharCode('9662');

    return (
      <Dropdown
        className={styles.control}
        isOpen={this.state.dropdownOpen}
        toggle={this.toggle}
      >
        <DropdownToggle
          tag="span"
          aria-expanded={this.state.dropdownOpen}
        >
          {currencySigns[currentCurrency]}{' '}{selectorActive && arrowSign}
        </DropdownToggle>
        {selectorActive && <DropdownMenu right>
          {availableOptions.map(option => this.renderOption(option))}
        </DropdownMenu>}
      </Dropdown>
    );
  }

}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/CurrencySelect.jsx